import React from "react";
import "./UserMenu.css";

function UserMenu({
  onClose,
  onOpenMyAds,
  onOpenProfile,
  onChangeAvatar,
  onLogout,
  avatarInputId = "user-menu-avatar-upload",
}) {
  return (
    <div className="user-menu-content" role="menu">
      <button
        type="button"
        className="user-menu-item"
        onClick={() => {
          onClose?.();
          onOpenMyAds?.();
        }}
        role="menuitem"
      >
        <span className="user-menu-icon">📋</span>
        <span>Οι αγγελίες μου</span>
      </button>

      <button
        type="button"
        className="user-menu-item"
        onClick={() => {
          onClose?.();
          onOpenProfile?.();
        }}
        role="menuitem"
      >
        <span className="user-menu-icon">👤</span>
        <span>Το προφίλ μου</span>
      </button>

      <button
        type="button"
        className="user-menu-item"
        onClick={() => {
          document.getElementById(avatarInputId)?.click();
        }}
        role="menuitem"
      >
        <span className="user-menu-icon">📷</span>
        <span>Αλλαγή φωτογραφίας</span>
      </button>

      <input
        id={avatarInputId}
        type="file"
        className="user-menu-hidden-input"
        onChange={onChangeAvatar}
      />

      <button
        type="button"
        className="user-menu-item user-menu-item-danger"
        onClick={() => {
          onClose?.();
          onLogout?.();
        }}
        role="menuitem"
      >
        <span className="user-menu-icon">🚪</span>
        <span>Έξοδος</span>
      </button>
    </div>
  );
}

export default UserMenu;